module.exports = __webpack_public_path__ + "media/assets/icons/location-pin-blue-c91e8e8af496f0da6f7cbcb9f2994180.svg";